module.exports = __webpack_public_path__ + "static/SuperbikeWhite-f2edbdc14c99a9e3fc000d99754ef54d.webm";